/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanySearchRequest
 */
export interface CompanySearchRequest {
    /**
     * 
     * @type {string}
     * @memberof CompanySearchRequest
     */
    organizationId?: string;
}

/**
 * Check if a given object implements the CompanySearchRequest interface.
 */
export function instanceOfCompanySearchRequest(value: object): value is CompanySearchRequest {
    return true;
}

export function CompanySearchRequestFromJSON(json: any): CompanySearchRequest {
    return CompanySearchRequestFromJSONTyped(json, false);
}

export function CompanySearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanySearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function CompanySearchRequestToJSON(value?: CompanySearchRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationId': value['organizationId'],
    };
}

